/**
 * Sticky Header — Adds scrolled class + hide/show on scroll direction
 */
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('.header');
    this.lastScroll = 0;
    this.scrollThreshold = 50;
  }

  connectedCallback() {
    this.onScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  handleScroll() {
    const currentScroll = window.scrollY;

    if (currentScroll > this.scrollThreshold) {
      this.classList.add('scrolled');
    } else {
      this.classList.remove('scrolled');
    }

    this.lastScroll = currentScroll;
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}
